<template>
  <v-container class="background mx-auto" fluid>
    <v-row class="">
      <Breadcrumbs :items="breadcrumbs"/>
    </v-row>
    <v-row justify="center" v-if="userDIDInfo">
      <v-col cols="12" class="pa-0">
        <DidManager :didInfo="userDIDInfo" @selectDid="handleSelectDid" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import apiCalls from "@/mixins/apiCalls.js";
import Breadcrumbs from "@/components/CommonComponents/Selects/Breadcrumbs";

export default {
  name: "DIDView",
  mixins: [apiCalls],
  components: {
    Breadcrumbs,
    DidManager: () => import("@/components/User/UserDIDs/DidManager"),
  },
  data() {
    return {
      userDIDInfo: null,
      userDIDRoutingRules: null,
      selectedDID: null,
    };
  },
  mounted() {
    this.fetchDIDInfo();
  },
  watch: {
    $route() {
      // console.log('route change to', to)
      // console.log('route change from', from)
      this.fetchDIDInfo()
    },
  },

  computed: {
    ...mapState({
      account: (state) => state.account.account,
      user: (state) => state.user.profile,
    }),
    breadcrumbs() {
      return this.accountOwner ? [
      {
          text: 'חזרה לעמוד ראשי',
          link: true,
          exact: true,
          disabled: false,
          to: {
            name: 'profile', 
            params: {
                id: this.account.domain_id
            }
          }
        },
        {
          text: 'ניהול מנויים',
          link: true,
          exact: true,
          disabled: false,
          to: {
            name: 'users', 
          }
       },
       
        {
          text: `מנוי: ${this.user.profile.name}`,// 'מנוי',
          disabled: false,
          link: true,
          exact: true,
          to: {
            name: 'user-profile', 
            params: {
                id: this.user.domain_user_id
            }
          },
        },
        {
          text: "ניהול מספרים",// 'מנוי',
          disabled: false,
          link: true,
          exact: true,
          to: {
            name: 'dids', 
            params: {
                id: this.user.domain_user_id
            }
          },
        },
        {
          text: `מספר: ${this.$options.filters.formatedPhone(this.$route.params.id)}`,// 'מנוי',
          disabled: true,
        
        },
        
      ] : [
      {
          text: `מנוי: ${this.user.profile.name}`,// 'מנוי',
          disabled: false,
          link: true,
          exact: true,
          to: {
            name: 'user-profile', 
            params: {
                id: this.user.domain_user_id
            }
          },
        },
        {
          text: "ניהול מספרים",// 'מנוי',
          disabled: false,
          link: true,
          exact: true,
          to: {
            name: 'dids', 
            params: {
                id: this.user.domain_user_id
            }
          },
        },
        {
          text: `מספר: ${this.$options.filters.formatedPhone(this.user.profile.id)}`,// 'מנוי',
          disabled: true,
         
        },
      ]
      },
  },
  methods: {
    ...mapActions(["setUserProfile"]),
    async fetchDIDInfo() {
      // console.log("fetch did ");
      const appAction = false;
      const functionName = "get_did_info";
      const reqBody = {
        number: this.$route.params.id,
        fake: false,
      };
      const data = await this.makeApiRequest(appAction, functionName, reqBody);
      // console.log("data : ", data);
      if (data.error_code === 200) {
        this.userDIDInfo = data.data;
      }
    },
    async fetchDIDRoutingRules() {
      const appAction = false;
      const functionName = "get_routing_rules";
      const reqBody = {
        viewer_entity_type: "user",
        viewer_entity_id: 894,
        category: "robokiller",
        show_hidden: true,
      };
      const data = await this.makeApiRequest(appAction, functionName, reqBody);
      if (data.error_code === 200) {
        this.userDIDRoutingRules = data.data;
      }
    },
    async fetchDIDFunctions() {
      const appAction = false;
      const functionName = "get_did_functions";
      const reqBody = {};
      const data = await this.makeApiRequest(appAction, functionName, reqBody);
      if (data.error_code === 200) {
        this.userDIDFunctions = data.data;
      }
    },
    handleSelectDid(payload) {
      // console.log("payload", payload);
      this.$router
        .push(`/user/${this.user.domain_user_id}/did/${payload}`)
        .catch((error) => {
          if (
            error.name !== "NavigationDuplicated" &&
            !error.message.includes(
              "Avoided redundant navigation to current location"
            )
          ) {
            console.log(error);
          }
        });
        this.userDIDInfo = null
        this.fetchDIDInfo()
    },

  },
};
</script>
